<template>
    <div class="box contact" @click="contact.open = ! contact.open" :class="{'is-open' : contact.open }">
        <div class="contact-head">
            <img :src="contactImage" class="contact-image" />
            <p class="contact-name">{{ contact.firstName }} <b>{{contact.lastName}}</b><br /><small>{{contact.work_position}}</small></p>
            <i class="icon-plus-circled"></i>
        </div>

        <transition name="contactbox">
            <div v-if="contact.open" @click.stop>
                <div class="contact-data">

                        <p class="contact-info contact-info--email" v-if="contact.email"><i class="icon-mail" title="E-Mail"></i> <a :href="'mailto:' + contact.email">{{contact.email}}</a></p>
                        <p class="contact-info contact-info--phone" v-if="contact.telephone"><i class="icon-telefon" title="Telefon"></i> <a :href="'tel:' + contact.telephone">{{contact.telephone}}</a></p>
                        <p class="contact-info contact-info--mobil" v-if="contact.mobil"><i class="icon-smartphone" title="Handy"></i> <a :href="'tel:' + contact.mobil">{{contact.mobil}}</a></p>
                        <p class="contact-info contact-info--fax" v-if="contact.fax"><i class="icon-print" title="Fax"></i> <a :href="'fax:' + contact.fax">{{contact.fax | phone}}</a></p>
                        <p class="contact-info contact-info--favorite" :class="{'is-active' : isFavorite }" @click="setFavorite">
                            <i :class="{'icon-stern': isFavorite,'icon-stern_kontur' : ! isFavorite}"></i> Als Favorit markieren
                        </p>
                        <template v-if="contact.address">
                            <address>{{contact.address}}<br>{{contact.zip}} {{contact.city}}<br />{{contact.country}}</address>
                        </template>

                </div>
<!--                <div class="contact-actions" @click.stop="non">-->
<!--                    <label class="contact-action contact-action&#45;&#45;favorite"><input type="checkbox" :checked="isFavorite" @click.prevent="setFavorite"><i :class="{'icon-stern': isFavorite,'icon-stern_kontur' : ! isFavorite}"></i></label>-->
<!--                    <a class="contact-action contact-action&#45;&#45;mobil" v-if="contact.mobil" :href="'tel:' + contact.mobil"><i class="icon-smartphone"></i></a>-->
<!--                    <span v-else class="contact-action contact-action&#45;&#45;mobil contact-action&#45;&#45;disabled"><i class="icon-smartphone"></i></span>-->
<!--                    <a class="contact-action contact-action&#45;&#45;fax" v-if="contact.fax" :href="'fax:' + contact.fax"><i class="icon-print"></i></a>-->
<!--                    <span v-else class="contact-action contact-action&#45;&#45;faxx contact-action&#45;&#45;disabled"><i class="icon-print"></i></span>-->
<!--                    <a class="contact-action contact-action&#45;&#45;phone" v-if="contact.telephone" :href="'tel:' + contact.telephone"><i class="icon-telefon"></i></a>-->
<!--                    <span v-else class="contact-action contact-action&#45;&#45;phone contact-action&#45;&#45;disabled"><i class="icon-telefon"></i></span>-->
<!--                </div>-->
            </div>
        </transition>

    </div>
</template>

<script>
    import { FAV_ADD, FAV_REMOVE } from '../../utils/store/actions/favorites';


    export default {
        name: "ContactBox",
        data() {
            return {
                'favorite': false
            };
        },
        props: [ 'contact' ],
        computed: {
            isFavorite: function () {
                return this.$store.getters.isFavorite({group: 'contacts', uid: this.contact.uid});
            },
            contactImage: function () {
                if ( this.contact.image !== null ) return this.contact.image;
                return require('@/assets/images/icons/ic_profil.svg');
            }
        },
        filters: {
            phone: ( phone ) => {
                return phone.replace(/(.{3})(.{4})(\d{4})/, '$1 $2 $3');
            }
        },
        methods: {
            // non: function () {},
            setFavorite: function ( evt ) {
                if ( ! this.isFavorite ) {
                    this.$store.dispatch(FAV_ADD, {group: 'contacts', uid: this.contact.uid});
                }
                else {
                    this.$store.dispatch(FAV_REMOVE, {group: 'contacts', uid: this.contact.uid});
                }
            }
        }
    };
</script>

<style scoped>
    .contact {
        overflow: hidden;
        font-weight: 400;
        position: relative;
    }

    .contact::after {
        /*content: '';*/
        display: table;
        clear: both;
    }

    .contact .icon-plus-circled {
        /*position: absolute;*/
        /*top: 29px;*/
        /*right: 20px;*/
        /*transform: translateY(-50%);*/
        transform-origin: 50% 50%;
        transition: transform .125s linear;
        font-size: 18px;
        color: #A1AAB3;
        margin-left: auto;
    }

    .contact.is-open .icon-plus-circled {
        transform: rotate(-45deg);
    }

    .contact-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .contact-name {
        margin: 0;
        font-size: 14px;
        line-height: 1.3;
    }

    .contact-name b {
        font-weight: 700;
    }
    .contact-name small {
        line-height: 1.3;
    }

    .contact-favorite {
        margin-left: auto;
        /*margin-right: 15px;*/
    }

    .contact-actions {
        display: flex;
        margin-top: 15px;
        font-size: 18px;
        width: 100%;
        justify-content: space-between;
        border-top: 1px solid rgba(255, 255, 255, .25);
        padding: 14px 0;
    }

    .contact-action {
        margin-left: 15px;
        width: 2ch;
    }

    .contact-action.contact-action--favorite {
    }

    .contact-action.contact-action--favorite input {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        visibility: hidden;
    }

    .contact-action.contact-action--favorite .icon-stern {
        color: #FCC326;
    }

    .contact-action.contact-action--disabled {
        opacity: .1;
    }

    .contact-data {
        margin-top: 15px;
        font-weight: 400;
        /*font-size: .8em;*/
        line-height: calc(24 / 18);
        display: flex;
        /*align-items: flex-start;*/
        flex-direction: column;
    }

    .contact-data address {
        margin-top: 12px;
        font-style: normal;
    }

    .contact-info {
        margin-top: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        background: #42556B;
        border-radius: 3px;
        display: block;
        font-size: 14px;
        padding: 12px;
    }

    .contact-info + .contact-info {
        margin-top: 5px;
    }
    .contact-info a {
        display: inline-block;
    }
    .contact-info i::before {
        font-size: 18px;
        margin-right: 12px;
    }
    .contact-info--favorite {
        font-weight: bold;
    }
    .contact-info--favorite.is-active {
        color: #FCC326;
    }
    .contact-info--position {
        font-style: italic;
    }

    .contact-image {
        float: left;
        margin-right: 10px;
        width: 33px;
        height: 33px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
    }
</style>



// WEBPACK FOOTER //
// src/components/subparts/ContactBox.vue